<script>
  import { onMount } from 'svelte'
  import { getAccountBalance } from '../../models/giftCard.js'
  import { formatPrice, formatDate } from '../../services/utilities.js'
  import Alert from '../../components/Alert.svelte'
  import GiftCardLookup from '../../components/GiftCardLookup.svelte'

  export let refer = null
  let details = { balance: 0, history: [] }
  let error = null

  onMount(async () => {
    if (refer === 'my-account') {
      await getDetails()
    }
  })

  async function getDetails() {
    error = null
    let accountBalance = await getAccountBalance()
    if (accountBalance.error) {
      error = `Error: ${accountBalance.error}`
    } else {
      details = accountBalance
    }
  }
</script>

<style type="text/less">
  .balance-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--col-accent-2);
    color: var(--col-gray-100);
    border-radius: 8px;
    padding: var(--spacing);
    margin-bottom: var(--spacing);
  }

  .balance-label {
    font-size: var(--font-size-xs);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    opacity: 0.75;
    margin-bottom: var(--spacing-xs);
  }

  .balance-amount {
    font-size: var(--font-size-xl);
    font-weight: 700;
    line-height: 1;
  }

  .balance-icon {
    opacity: 0.3;
    .icon {
      width: 2.5rem;
      height: 2.5rem;
    }
  }

  .section-heading {
    font-size: var(--font-size-sm);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--col-gray-50);
    font-weight: 600;
    margin-bottom: var(--spacing-sm);
  }

  .lookup-section {
    margin-bottom: var(--spacing);
    padding-bottom: var(--spacing);
    border-bottom: 1px solid var(--col-gray-90);
  }

  .history-table {
    width: 100%;
    border-collapse: collapse;
    font-size: var(--font-size-sm);

    th {
      text-align: left;
      padding: var(--spacing-xs) var(--spacing-sm);
      border-bottom: 2px solid var(--col-gray-80);
      color: var(--col-gray-40);
      font-weight: 600;
      font-size: var(--font-size-xs);
      text-transform: uppercase;
      letter-spacing: 0.06em;
    }

    td {
      padding: var(--spacing-xs) var(--spacing-sm);
      border-bottom: 1px solid var(--col-gray-90);
      vertical-align: middle;
    }

    tr:last-child td {
      border-bottom: none;
    }
  }

  .amount-col {
    text-align: right;
    font-weight: 600;
    white-space: nowrap;
  }

  .date-col {
    color: var(--col-gray-50);
    white-space: nowrap;
  }

  .empty-history {
    color: var(--col-gray-50);
    font-style: italic;
    font-size: var(--font-size-sm);
    padding: var(--spacing-sm) 0;
  }
</style>

{#if error}
  <Alert type="danger" icon="warning">{error}</Alert>
{/if}

{#if refer === 'my-account'}
  <h2>Gift Cards</h2>

  <div class="balance-card">
    <div>
      <div class="balance-label">Account Balance</div>
      <div class="balance-amount">{formatPrice(details.balance)}</div>
    </div>
    <div class="balance-icon">
      <svg class="icon"><use href="/icons.svg#gift"></use></svg>
    </div>
  </div>

  <div class="lookup-section">
    <div class="section-heading">Redeem a Gift Card</div>
    <GiftCardLookup {refer} callback={() => getDetails()} />
  </div>

  <div>
    <div class="section-heading">Activity</div>
    {#if details.history.length > 0}
      <table class="history-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Description</th>
            <th class="amount-col">Amount</th>
          </tr>
        </thead>
        <tbody>
          {#each details.history as row}
            <tr>
              <td class="date-col">{formatDate(row.created_at, { showTime: false })}</td>
              <td>{row.description}</td>
              <td class="amount-col">{formatPrice(row.amount)}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    {:else}
      <p class="empty-history">No gift card activity yet.</p>
    {/if}
  </div>
{:else}
  <h2>Gift Card Balance</h2>
  <p>Find the gift card code in the email with your gift card details.</p>
  <GiftCardLookup />
{/if}
